import React, {Component} from 'react';
import SocialMedia from '../../../../Shared/components/Contact/SocialMedia';
import {browserHistory} from 'react-router';
import {PATH_PROTECTORA_ID} from "../../../../../App/RouterAdopta";
import Descripcion from "../../../../Shared/components/components/Descripcion/Descripcion";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ELEMENTS, TIPOS_EVENTOS} from "../../../../../analytics/config/analyticsParamsFrontEnd";
import {sendEvent} from "../../../../../analytics/analitycs"


class CardInfoAnimalDetailProtectora extends Component {
    
    constructor(props) {
        super(props);
        
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoProtectora",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Alguna pregunta?"],
            messageWhatsapp: "Hola%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20vosotros%20",
            idSelect: "contactoProtectora",
            divSelect: '.divSelectContactoProtectora',
            tipo: 'protectora'
        };
        
        //Config información
        this.configInformation = {
            titleHead: "Redes Sociales",
            socials: [
                {
                    url: this.props.infoProtectoraDetail.facebook && this.props.infoProtectoraDetail.facebook.url ? this.props.infoProtectoraDetail.facebook.url : '',
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: this.props.infoProtectoraDetail.twitter && this.props.infoProtectoraDetail.twitter.url ? this.props.infoProtectoraDetail.twitter.url : '',
                    socialIcon: "lab la-twitter"
                },
                {
                    url: this.props.infoProtectoraDetail.instagram && this.props.infoProtectoraDetail.instagram.url ? this.props.infoProtectoraDetail.instagram.url : '',
                    socialIcon: "lab la-instagram"
                },
            
            ],
            teaming: this.props.infoProtectoraDetail.teaming && this.props.infoProtectoraDetail.teaming.url && this.props.infoProtectoraDetail.teaming.nick ? this.props.infoProtectoraDetail.teaming : '',
            
            
        };
        
        this.showProtectora = this.showProtectora.bind(this);
        this.clickLinkDescripcion = this.clickLinkDescripcion.bind(this);
        this.clickLinkTeamingDescripcion = this.clickLinkTeamingDescripcion.bind(this);
        this.clickEmailDescripcion = this.clickEmailDescripcion.bind(this);
    }
    
    showProtectora(e) {
        browserHistory.push(PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id);
    }
    
    clickLinkDescripcion() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.LINK_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
    }
    
    clickLinkTeamingDescripcion() {
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.TEAMING_BUTTON, {id_protectora: this.props.infoProtectoraDetail._id});
    }
    
    clickEmailDescripcion() {
        this.props.modeEmail(true, this.props.animalsControl);
        sendEvent(TIPOS_EVENTOS.CLIC, ELEMENTS.PROTECTORA.EMAIL_DESCRIPCION, {id_protectora: this.props.infoProtectoraDetail._id});
        
    }
    
    
    render() {
        let showInfo = false;
        let direccion;
        let especie;
        
        
        let loc
        if (Object.keys(this.props.infoProtectoraDetail).length !== 0) {
            showInfo = true;
            especie = this.props.especie || "Perro";
            
            const direccionObj = this.props.infoProtectoraDetail.direccion;
            if (direccionObj != null && direccionObj.ocultar_direccion_exacta) {
                direccion = "Zona de " + direccionObj.municipio + ", " + direccionObj.provincia;
            } else if (direccionObj != null && !direccionObj.ocultar_direccion_exacta && direccionObj.calle && direccionObj.numero) {
                direccion = direccionObj.calle + ", " + direccionObj.numero + ", " + direccionObj.municipio + ", " + direccionObj.provincia
            } else if (direccionObj != null && direccionObj.municipio && direccionObj.provincia) {
                direccion = direccionObj.municipio + " (" + direccionObj.provincia + ")"
            } else {
                direccion = "Consultar dirección";
            }
            loc = (direccionObj && direccionObj.municipio) ? direccionObj.municipio : (direccionObj.region) ? direccionObj.region : direccionObj.provincia
            
        }
        
        const url_img_principal = (this.props.infoProtectoraDetail.img_principal && this.props.infoProtectoraDetail.img_principal.url) ? this.props.infoProtectoraDetail.img_principal.url : process.env.CDN_URL+'/images/adoptaunanimal/default/protectora2.png'
        
        return (
            // <div className="card-block">
            <div className="">
                {showInfo &&
                    <div className="newCardInfoDetailShow">
                        <div className="sub-section">
                            
                            <div className="cardInfoTitle">
                                <h2 className="card-title"><span
                                    className="bold">{this.props.infoProtectoraDetail.nombre}</span></h2>
                            </div>
                            <div className="informationDetailDescription">
                                <div className="informationDetailDescriptionLeft">
                                    {/*<img src={process.env.CDN_URL + "/images/adoptaunanimal/default/protectora2.png"} alt=""*/}
                                    <LazyLoadImage
                                        src={url_img_principal}
                                        alt=""
                                        threshold={150}
                                        className="embed-responsive"/>
                                </div>
                                <div className="informationDetailDescriptionUpRight informationDetailProtectora">
                                    <div className="cardInfoTitle">
                                        <h2 className="card-subtitle">
                                            <span
                                                className="bold">{this.props.infoProtectoraDetail.tipo_entidad} </span>
                                            {loc &&
                                                <span> cerca de <span className="bold"> {loc}</span></span>
                                            }
                                        </h2>
                                    
                                    </div>
                                    <div>
                                        <div className="div-rrss-contacto-protectora">
                                            <div className="social-media-block">
                                                <SocialMedia
                                                    configInformation={this.configInformation}
                                                    animalsControl={this.props.animalsControl}
                                                    animalsControlDetail={this.props.animalsControlDetail}
                                                />
                                            </div>
                                        </div>
                                        <div className="buttonVerProtectora">
                                            <a
                                                href={PATH_PROTECTORA_ID + this.props.infoProtectoraDetail._id}
                                                data-id={this.props.infoProtectoraDetail._id}
                                                className="btn btn-outline-primary listing-houses__item-view-link">
                                                Ver más de <br/>{this.props.infoProtectoraDetail.nombre}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {this.props.infoProtectoraDetail.descripcion &&
                                <div className="sub-section">
                                    <hr/>
                                    <Descripcion
                                        title={""}
                                        descripcion={this.props.infoProtectoraDetail.descripcion}
                                        onClickLink={this.clickLinkDescripcion}
                                        onClickLinkTeaming={this.clickLinkTeamingDescripcion}
                                        onClickEmail={this.clickEmailDescripcion}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                }
                {!showInfo &&
                    <div className="informationDetail">
                        <div id="loaderImageIni">
                            {especie === "Perro" &&
                                <LazyLoadImage threshold={150} src={process.env.CDN_URL + "/images/adoptaunanimal/loader/dog.gif"}/>
                                // <img src={getImageEncode("dog-loader")}/>
                            }
                            {especie === "Gato" &&
                                <LazyLoadImage threshold={150} src={process.env.CDN_URL + "/images/adoptaunanimal/loader/cat.gif"}/>
                                // <img src={getImageEncode("cat-loader")}/>
                            }
                            <div className="loaderImageText">B U S C A N D O . . .</div>
                        </div>
                    </div>
                }
            </div>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    
    }
    
    componentDidUpdate() {
    }
    
    
}


export default CardInfoAnimalDetailProtectora